import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { StyledTab } from '../TabsTab/StyledTab.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["as", "selected"];
var defaultElement = "a";
var NavTabsTab = /*#__PURE__*/React.forwardRef(function NavTabsTab2(props, ref) {
  var _props$as = props.as,
      as = _props$as === void 0 ? defaultElement : _props$as,
      selected = props.selected,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/jsx(StyledTab, _objectSpread(_objectSpread({
    "aria-current": selected ? "page" : void 0,
    as: as
  }, rest), {}, {
    ref: ref
  }));
});
NavTabsTab.propTypes = {
  "as": _PropTypes.oneOfType([_PropTypes.string, _PropTypes.func, _PropTypes.object]),
  "selected": _PropTypes.bool
};
NavTabsTab.displayName = "NavTabsTab";

export { NavTabsTab };
